import api from './api';

// 获取会话列表
export const getSessions = async (page = 1, size = 20, keyword = '', sessionType = '') => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('size', size);
  
  if (keyword) {
    params.append('keyword', keyword);
  }
  
  if (sessionType) {
    params.append('sessionType', sessionType);
  }
  
  try {
    return await api.fetchWithToken(`/chat/getSessions?${params.toString()}`, {
      method: 'GET'
    });
  } catch (error) {
    throw error;
  }
};

// 获取历史消息
export const getHistoryMessages = async (sessionId, cursor = null) => {
  try {
    const params = new URLSearchParams();
    if (cursor !== null && cursor !== undefined) {
      params.append('cursor', cursor);
    }
    params.append('pageSize', '10');
    
    const url = `/chat/${sessionId}/getHistoryMessage?${params.toString()}`;
    
    const response = await api.fetchWithToken(url, {
      method: 'GET'
    });
    
    if (response.success) {
      const { records, nextCursor, hasMore } = response.data;
      
      // 确保nextCursor作为字符串处理
      let processedNextCursor = nextCursor;
      if (nextCursor !== null && nextCursor !== undefined && typeof nextCursor === 'number') {
        // 对于大整数，将其转换为字符串以避免精度问题
        processedNextCursor = String(nextCursor);
      }
      
      return {
        ...response,
        data: {
          records,
          nextCursor: processedNextCursor,
          hasMore
        }
      };
    }
    
    return response;
  } catch (error) {
    throw error;
  }
};

// 查找或创建单聊会话
export const findSingleSession = async (userId) => {
  try {
    return await api.fetchWithToken('/chat/findSingleSession', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId: userId
      })
    });
  } catch (error) {
    throw error;
  }
};

const chatApi = {
  getSessions,
  getHistoryMessages,
  findSingleSession
};

export default chatApi; 